import { Eraser } from "lucide-react";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecreateChat } from "~/api/chat/chat";
import { Button } from "~/components/ui/button";
import { ROUTES, useChatDocumentParams } from "~/helpers";

export const ClearChatButton: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { organizationId, caseId, chatId } = useChatDocumentParams();
  const { mutateAsync: recreateChat } = useRecreateChat();
  const navigate = useNavigate();

  const location = useLocation();

  const handleClearChat = async () => {
    const chat = await recreateChat({
      organizationId,
      projectId: caseId,
      data: {
        originalChatId: chatId,
      },
    });

    navigate(
      ROUTES.CHAT_DOCUMENT({
        organizationId,
        caseId,
        chatId: chat.id,
        searchParams: location.search,
      })
    );
  };

  return (
    <Button
      variant="ghost"
      size="mini"
      onClick={handleClearChat}
      disabled={disabled}
    >
      <Eraser className="w-4 h-4 mr-2" />
      <FormattedMessage id="common.clear" defaultMessage="Clear" />
    </Button>
  );
};
